import { render, staticRenderFns } from "./ContractFormatsModal.vue?vue&type=template&id=481ebad6&scoped=true"
import script from "./ContractFormatsModal.vue?vue&type=script&lang=js"
export * from "./ContractFormatsModal.vue?vue&type=script&lang=js"
import style0 from "./ContractFormatsModal.vue?vue&type=style&index=0&id=481ebad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ebad6",
  null
  
)

export default component.exports